'use strict';
import {runInjector} from '../_libs/angular-utils/index';
import {PersonItem} from './components/PersonItem';
import {PersonnelViewOverview} from './components/PersonnelViewOverview';
import {PersonnelViewPersonDetailsHeader} from './components/PersonnelViewPersonDetailsHeader';
import {PersonnelViewTeamDetailsHeader} from './components/PersonnelViewTeamDetailsHeader';
import {PersonnelViewTeamTypesHeader} from './components/PersonnelViewTeamTypesHeader';
import {PersonnelDetailController} from './controllers/PersonnelDetailController';
import {PersonnelHomeController} from './controllers/PersonnelHomeController';
import {PersonDirective} from './directives/PersonDirective';
import {PersonDomainProvider} from './domain/PersonDomain';
import {TeamDomainProvider} from './domain/TeamDomain';
import {TeamRoleDomainProvider} from './domain/TeamRoleDomain';
import {TeamTypeDomainProvider} from './domain/TeamTypeDomain';
import {TeamsEditFilterMixin} from './filters/TeamsEditFilterMixin';
import {routerConfig} from './router';

const angular = require('angular');

// Components
const LimitPersonnelDirective = require('./directives/LimitPersonnelDirective.js');
const PersonnelDirective = require('./directives/PersonnelDirective.js');

module.exports = angular
  .module('app.personnel', [])
  .config(routerConfig)
  .value('PersonnelViewOverview', PersonnelViewOverview)
  .run(runInjector(PersonItem))

  .service('PersonnelService', require('./services/PersonnelService.js'))

  .filter('abbreviate', require('./filters/name-initials.js'))
  .service('TeamsEditFilterMixin', TeamsEditFilterMixin)
  .service('PersonnelFilterMixin', require('./filters/PersonnelFilterMixin.js'))

  .provider('PersonDomain', PersonDomainProvider)
  .provider('TeamDomain', TeamDomainProvider)
  .provider('TeamRoleDomain', TeamRoleDomainProvider)
  .provider('TeamTypeDomain', TeamTypeDomainProvider)

  .directive('limitPersonnel', LimitPersonnelDirective.directive)
  .directive('personItem', PersonDirective)
  .directive('personnel', PersonnelDirective.directive)
  .controller('PersonnelController', PersonnelDirective.controller)

  /* Controllers - Admin */
  .controller('InvitesCreateController', require('./controllers/admin/InvitesCreateController.js'))
  .controller('InvitesImportController', require('./controllers/admin/InvitesImportController.js'))
  .controller('MembersManageController', require('./controllers/admin/MembersManageController.js'))
  .controller('TeamTypesCreateController', require('./controllers/admin/TeamTypesCreateController.js'))
  .controller('TeamTypesManageController', require('./controllers/admin/TeamTypesManageController.js'))

  /* Controllers */
  .controller('PersonnelCreateController', require('./controllers/PersonnelCreateController.js'))
  .controller('PersonnelDetailController', PersonnelDetailController)
  .controller('PersonnelHomeController', PersonnelHomeController)
  .controller('TeamsDetailController', require('./controllers/TeamsDetailController.js'))
  .controller('TeamsEditDialogController', require('./controllers/TeamsEditDialogController.js'))
  .directive('personnelViewPersonDetailsHeader', ['reactDirective', reactDirective =>
    reactDirective(PersonnelViewPersonDetailsHeader),
  ])
  .directive('personnelViewTeamDetailsHeader', ['reactDirective', reactDirective =>
    reactDirective(PersonnelViewTeamDetailsHeader),
  ])
  .directive('personnelViewTeamTypesHeader', ['reactDirective', reactDirective =>
    reactDirective(PersonnelViewTeamTypesHeader),
  ])
;



// WEBPACK FOOTER //
// ./src/js/personnel/index.js